/**
 * Genemo ブランド資産（family-design/brand）への参照を1か所に集める。
 * 画像は Vite の静的 import でハッシュ付き URL にする（ビルド後の配信パスを確定させるため）。
 * アプリ一覧は family-design/apps.ts の GENEMO_APPS が唯一の正本。
 */
import { GENEMO_APPS, type GenemoApp } from '../../../family-design/apps'
import logoShortUrl from '../../../family-design/brand/logo/genemo-short.svg'
import logoShortWhiteUrl from '../../../family-design/brand/logo/genemo-short-w.png'
import logoShortMarkUrl from '../../../family-design/brand/mark/genemo-short-mark.png'
import rakuripMarkUrl from '../../../family-design/brand/partner/rakurip-mark.png'

export { GENEMO_APPS }
export type { GenemoApp }

/** このアプリ（Short）のロゴ(横)とマーク */
export const SHORT_LOGO_URL = logoShortUrl
/** 暗い背景用（白抜き）のロゴ。LP など暗い面でだけ使う */
export const SHORT_LOGO_ON_DARK_URL = logoShortWhiteUrl
export const SHORT_MARK_URL = logoShortMarkUrl
/** 「ラクリプでログイン」ボタン用の公式マーク（色・形を変えない） */
export const RAKURIP_MARK_URL = rakuripMarkUrl

const marks = import.meta.glob('../../../family-design/brand/mark/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>

/** アプリのマーク画像 URL（apps.ts の logo 基幹名から解決） */
export function appMarkUrl(app: GenemoApp): string {
  return marks[`../../../family-design/brand/mark/${app.logo}-mark.png`] ?? ''
}
